import { render, staticRenderFns } from "./RiskScorePopup.vue?vue&type=template&id=75e2361c&scoped=true"
import script from "./RiskScorePopup.vue?vue&type=script&lang=js"
export * from "./RiskScorePopup.vue?vue&type=script&lang=js"
import style0 from "./RiskScorePopup.vue?vue&type=style&index=0&id=75e2361c&prod&lang=scss"
import style1 from "./RiskScorePopup.vue?vue&type=style&index=1&id=75e2361c&prod&lang=scss&scoped=true"
import style2 from "./RiskScorePopup.vue?vue&type=style&index=2&id=75e2361c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e2361c",
  null
  
)

export default component.exports